import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';
import { ICONS } from './iconRegistry';

const IncludedInFee = ({ items }) => {
  return (
    <section id="included" className={styles.mint}>
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>What&apos;s Included In The Fee</h2>
          <p>
            The tools and cloud access you need for the projects are part of the program. We will
            use free tiers and resources wherever sufficient.
          </p>
        </div>
        <div className={styles.cards2}>
          {items.map((item) => {
            const Icon = ICONS[item.icon];
            return (
              <div className={styles.mini} key={item.h}>
                <div className={styles.num}>{Icon && <Icon size={18} aria-hidden="true" />}</div>
                <div>
                  <h4>{item.h}</h4>
                  <span className={styles.tag}>Provided</span>
                </div>
              </div>
            );
          })}
        </div>
        <p className={styles.note}>
          Every project comes with a starter repo, automated tests and a rubric. The local lab
          stack runs on your laptop with one Docker compose file, for free.
        </p>
      </div>
    </section>
  );
};

export default IncludedInFee;
